import AppLayout from '@/layout/AppLayout.vue'

const ProofOfReserves = () => import('@/view/proofOfReserves/ProofOfReserves.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/proofOfReserves',
        component: ProofOfReserves,
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
